import { z } from "zod";

export const bFileStatusEnum = z.enum([
  "UPLOADING",
  "UPLOADED",
  "UPLOAD_DENIED", // todo remove
  "UPLOAD_FAILED", // todo remove
]);
export type BFileStatus = z.infer<typeof bFileStatusEnum>;
